import { createContext, useContext, useEffect, useState } from 'react';
import { getThemeSite } from 'services/settingService';

const SeasonThemeContext = createContext();

export function SeasonThemeProvider({ children }) {
  // Thème initial issu d'une source persistée pour éviter le "switch" visuel au premier rendu
  const persistedTheme = typeof window !== 'undefined'
    ? (localStorage.getItem('seasonTheme') || document.documentElement.getAttribute('data-season-theme'))
    : null;
  const [seasonTheme, setSeasonTheme] = useState(persistedTheme || 'default');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Appliquer dès le montage l'attribut data selon la valeur initiale
    document.documentElement.setAttribute('data-season-theme', seasonTheme);

    const fetchSeasonTheme = async () => {
      try {
        const response = await getThemeSite();
        const currentTheme = response?.data?.hub_status || response?.data?.theme || 'default';
        setSeasonTheme(currentTheme);
        document.documentElement.setAttribute('data-season-theme', currentTheme);
        try { localStorage.setItem('seasonTheme', currentTheme); } catch (_) {}
      } catch (error) {
        console.error('Erreur lors du chargement du thème saisonnier:', error);
        setSeasonTheme('default');
        document.documentElement.setAttribute('data-season-theme', 'default');
        try { localStorage.setItem('seasonTheme', 'default'); } catch (_) {}
      } finally {
        setIsLoading(false);
      }
    };

    fetchSeasonTheme();
  }, []);

  const updateSeasonTheme = (newTheme) => {
    setSeasonTheme(newTheme);
    document.documentElement.setAttribute('data-season-theme', newTheme);
  };

  return (
    <SeasonThemeContext.Provider value={{ 
      seasonTheme, 
      updateSeasonTheme, 
      isLoading 
    }}>
      {children}
    </SeasonThemeContext.Provider>
  );
}

export function useSeasonTheme() {
  const context = useContext(SeasonThemeContext);
  if (!context) {
    throw new Error('useSeasonTheme must be used within a SeasonThemeProvider');
  }
  return context;
}
